export class WhyUs {
  static reasons: string[] = [
    "A Broadfactor é autorizada pelo Ministério da Economia para antecipar recebíveis de contratos com o governo.",
    "Oferecemos soluções rápidas, flexíveis e personalizadas para o seu negócio.",
    "Utilizamos tecnologia para simplificar e agilizar a antecipação, garantindo que você receba seu dinheiro sem complicações.",
    "Atendimento exclusivo. Suporte rápido e humanizado."
  ]
}
